<template>
    <div>
        <h1 class="display-heading">Invitation Report ({{invitationTypeDisplay}})</h1>

        <div ref="tableSection">
            <div class="table-responsive">
                <table ref="listTable" class="table table-hover">
                    <colgroup>
                        <col width="40">
                        <col width="140">
                        <col>
                        <col>
                        <col width="180">
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col" class="text-nowrap">Invitation Date</th>
                            <th scope="col" class="text-nowrap">Full Name</th>
                            <th scope="col" class="text-nowrap">Email Address</th>
                            <th scope="col" class="text-nowrap">Status</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-show="invitationList.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>

                        <tr v-for="(invite, index) in invitationList" :key="index">
                            <th scope="row">{{((pagination.currentPage - 1) *pagination.pageSize ) + index + 1}}</th>
                            <td class="text-nowrap">
                                {{invite.inviteDate}}
                            </td>
                            <td class="text-nowrap">
                                {{invite.name ? invite.name : '-'}}
                            </td>
                            <td class="text-nowrap">
                                {{invite.email}}
                            </td>
                            <td class="text-nowrap">
                                {{invite.status}}
                            </td>
                        </tr>

                    </tbody>
                </table>
                <pagination v-model="pagination.currentPage"
                    :totalPages="pagination.totalPages"
                    :scrollPosition="pagination.scrollPosition">
                </pagination>
            </div>
        </div>
    </div>
</template>

<script>
import {
    convertToUserReadableDateTime
} from '@/utilities';
import pagination from '@/components/pagination';
export default {
    'name': 'SuperAdminUserInvitationReport',
    'components': {
        pagination
    },
    mounted () {
        this.filterInvitationType = (this.$route.query &&
        this.$route.query.invitationType &&
        [1, 2, 3, 4, 5].includes(parseInt(this.$route.query.invitationType)))
            ? parseInt(this.$route.query.invitationType) : 1;

        this.$router.push({ 'query': { 'invitationType': this.filterInvitationType } });
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getList();
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        },
        invitationTypeDisplay () {
            let type = 'Public Users';

            switch (this.filterInvitationType) {
            case 2:
                type = 'Doctors';
                break;
            case 3:
                type = 'Pharmacies';
                break;
            case 4:
                type = 'Companies';
                break;
            case 5:
                type = 'Clinics';
                break;
            }

            return type;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getList();
            });
        }
    },
    data () {
        return {
            'filterInvitationType': 4,
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'invitationList': []
        };
    },
    'methods': {
        getList () {
            this.axios.post('Invite/GetSuperAdminInvitationReport', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize,
                't': this.filterInvitationType
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.invitationList = list.map((invite) => ({
                    'email': invite.e,
                    'name': invite.n,
                    'inviteDate': convertToUserReadableDateTime(invite.ca),
                    'status': invite.s
                }));
            });
        }
    }
};
</script>
